module.exports = __webpack_public_path__ + "img/groups.2168b24c.svg";